import { erpApi } from "@/shared/axios";
import { ROUTER_PATHS, urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { IPreventaCorporativo, IPreventaCorporativoForm2, IPreventaCorporativoParams, IPreventaCorporativoResp } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import { string } from "yup";

const { get, post, put } = erpApi()

///* Obtener preventas corporativos
export const fetchGetPreventasCorporativos = (
  params: IPreventaCorporativoParams
) => {

  return useQuery({
    queryKey: ['preventacoorporativa', ...Object.values(params || {})],
    queryFn: async () => {
      return await getPreventasCorporativos(params)
    },
    refetchOnWindowFocus: false,

  })
}
export const getPreventasCorporativos = async (data: IPreventaCorporativoParams) => {
  const queryParams = getUrlParamsFetch(data || {})
  return await get<IPreventaCorporativoResp>(`${urlBackend}api/v1/preventacoorporativa/?${queryParams}`, true);
}


///* Buscar preventa corporativa por id

export const fetchGetByIdPreventasCorporativos = (
  id: string
) => {
  return useQuery({
    queryKey: ['preventacoorporativa', id],
    queryFn: async () => {
      return await getByIdPreventasCorporativos(id)
    },
    refetchOnWindowFocus: false,
    gcTime: 100,

  })
}

export const getByIdPreventasCorporativos = async (id: string) => {
  return await get<IPreventaCorporativoForm2>(`${urlBackend}api/v1/preventacoorporativa/${id}/`, true);
}


///* Crear una preventa corporativa
export const fetchPostPreventaCorporativo = (
  {
    enableSuccessAlert,
    navigate
  }: UseMutationsParams
) => {

  const setAlert = useUiStore.getState().setAlert
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postPreventaCorporativo,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['preventacoorporativa'] });

      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && navigate(ROUTER_PATHS.ventasCorporativas.preventaCorporativoNav)
    },
    onError: (error) => handleAxiosError(error),
    onSettled: () => {

    }
  })
}

export const postPreventaCorporativo = async (data: IPreventaCorporativoForm2) => {
  return await post<IPreventaCorporativo>(`${urlBackend}api/v1/preventacoorporativa/`, data, true)
}

///* Actualizar una preventa corporativa
export const fetchPutPreventaCorporativo = (
  {
    enableSuccessAlert,
    navigate,
    returnUrl
  }: UseMutationsParams
) => {

  const setAlert = useUiStore.getState().setAlert
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putPreventaCorporativo,
    onSuccess: (data) => {

      queryClient.invalidateQueries({ queryKey: ['preventacoorporativa'] });

      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && returnUrl && navigate(returnUrl)
    },
    onError: (error) => handleAxiosError(error),
    onSettled: () => {

    }
  })
}

export const putPreventaCorporativo = async (data: Partial<IPreventaCorporativoForm2>) => {
  return await put<IPreventaCorporativo>(`${urlBackend}api/v1/preventacoorporativa/${data.id_preventa_coorporativa}/`, data, true)
}
